import { companyConstants } from "../_constants";

export function companyProfile(state = {}, action) {
  switch (action.type) {
    case companyConstants.GET_COMPANY_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case companyConstants.GET_COMPANY_DETAILS_SUCCESS:
      return {
        item: action.company,
      };
    case companyConstants.GET_COMPANY_DETAILS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function editCompany(state = {}, action) {
  switch (action.type) {
    case companyConstants.EDIT_COMPANY_PROFILE_REQUEST:
      return {
        loading: true,
      };
    case companyConstants.EDIT_COMPANY_PROFILE_SUCCESS:
      return {
        item: action.company,
      };
    case companyConstants.EDIT_COMPANY_PROFILE_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function companyLogo(state = {}, action) {
  switch (action.type) {
    case companyConstants.GET_COMPANY_LOGO_REQUEST:
      return {
        loading: true,
      };
    case companyConstants.GET_COMPANY_LOGO_SUCCESS:
      return {
        item: action.logo,
      };
    case companyConstants.GET_COMPANY_LOGO_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function dashboardDropdownData(state = {}, action) {
  switch (action.type) {
    case companyConstants.GET_DASHBOARD_DROPDOWN_DATA_REQUEST:
      return {
        loading: true,
      };
    case companyConstants.GET_DASHBOARD_DROPDOWN_DATA_SUCCESS:
      return {
        item: action.data,
      };
    case companyConstants.GET_DASHBOARD_DROPDOWN_DATA_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function costDashboardData(state = {}, action) {
  switch (action.type) {
    case companyConstants.GET_COST_DASHBOARD_DATA_REQUEST:
      return {
        loading: true,
      };
    case companyConstants.GET_COST_DASHBOARD_DATA_SUCCESS:
      return {
        item: action.data,
      };
    case companyConstants.GET_COST_DASHBOARD_DATA_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
